import { styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { SubmiticaGreen } from "styles/colours";

type SubmiticaOutageProps = {
  outageMessage: string;
};

const OutageContainer = styled(Grid)(() => ({
  backgroundColor: SubmiticaGreen,
  height: "100vh"
}));

const OutageDiv = styled(Grid)(() => ({
  padding: "30px",
  alignItems: "center",
  display: "flex"
}));

const SubmiticaOutage = (props: SubmiticaOutageProps) => {
  const isScreenSmall = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <OutageContainer container>
      <OutageDiv size={{ xs: 12, md: 6 }}>
        <Grid>
          <Typography
            variant={isScreenSmall ? "h4" : "h2"}
            style={{ clear: "both" }}
          >
            Sorry
          </Typography>
          <Typography variant={isScreenSmall ? "h5" : "h3"}>
            {props.outageMessage}
          </Typography>
        </Grid>
      </OutageDiv>
    </OutageContainer>
  );
};

export default SubmiticaOutage;
